import React from 'react';

import { DrawerHeader as ChakraDrawerHeader } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Cross } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';

const StyleCloseButton = styled(Button)`
  position: absolute;
  left: ${(props) => (props.isMobileView ? '0px' : '-14px')};
  top: -14px;

  padding: 2px;
  height: 28px;

  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors.neutral.F5F7F9};
  &:hover {
    background-color: #125aa9;
  }
`;

export const DrawerHeader = ({ children, showCloseButton = true, onClose, ...props }) => (
  <ChakraDrawerHeader
    //  py={1} pt={3} px={5}
    pos="relative"
    p={0}
    {...props}
  >
    {children}
    {showCloseButton ? (
      <StyleCloseButton
        variant="filled"
        color="black"
        StartIcon={Cross}
        startIconProps={{
          onClick: (e) => {
            e.stopPropagation();
            onClose();
          },
          boxSize: '20px',
        }}
        onClick={onClose}
        className="close-button-drawer"
        isMobileView={isMobileView()}
        data-testid="bottom-drawer-close-button"
      />
    ) : null}
  </ChakraDrawerHeader>
);

export const DrawerHeaderSecondary = ({ children, showCloseButton = true, onClose, ...props }) => (
  <ChakraDrawerHeader
    //  py={1} pt={3} px={5}
    pos="relative"
    p={0}
    {...props}
  >
    {children}
    {showCloseButton ? (
      <StyleCloseButton
        variant="filled"
        color="black"
        StartIcon={Cross}
        startIconProps={{
          onClick: (e) => {
            e.stopPropagation();
            onClose();
          },
          boxSize: '20px',
        }}
        onClick={onClose}
        left="-22px !important"
        top="-22px !important"
      />
    ) : null}
  </ChakraDrawerHeader>
);
